import { Moment } from 'moment';
import * as momentImported from 'moment-timezone';

const moment = momentImported;

export const DATE_KEY = 'DD/MM/YYYY';

export const createKeyDate = (date: Date | string) => {
  return moment(date).format(DATE_KEY);
};

export const fromUTCToTimezone = (dateInUTC: string, timeZoneIdentifier: string): Moment => {
  return moment.utc(dateInUTC).tz(timeZoneIdentifier);
};

export const fromUTCToBrowser = (dateInUTC: string): Moment => {
  return moment.utc(dateInUTC).local();
};
